import { __decorate, __metadata } from "tslib";
import { IsUUID } from 'class-validator';
export class ListLocationsByCourtSystemRequest {
    /**
     *
     * @param courtSystemId
     * @param parentId  Deprecated: This is not used and will be removed in a future release
     */
    constructor(courtSystemId, _parentId) {
        this.courtSystemId = courtSystemId;
    }
}
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], ListLocationsByCourtSystemRequest.prototype, "courtSystemId", void 0);
